import React from "react";
 
const SectionSix = () => {

  return (
<main className="flex flex-col md:flex-row items-center min-h-screen bg-white" role="main">

      {/* Left Content Section */}
<section className="md:w-[60%] w-full flex flex-col justify-center items-center p-6" aria-label="Injury Lawyer Information">
<div className="max-w-2xl w-full">
<header>
<h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Why Do I Need to Hire a Lawyer?</h1>
</header>
<div className="mb-4">
<p className="text-base md:text-lg text-gray-700 mb-2">

              After a crash, whether a minor fender bender or a catastrophic rollover, insurance companies move fast to offer low settlements. A skilled personal injury attorney knows how to document your losses, negotiate with insurers, and pursue full compensation for medical bills, lost income, and emotional trauma.
</p>
<p className="text-base md:text-lg text-gray-700">

              They'll also guide you through your state's laws and deadlines, so you don't miss critical filing windows. Whether you're recovering from whiplash, spinal stenosis, or a concussion, your lawyer will help you understand your legal options, and you won't pay unless they win. We also connect you with Karnataka-based attorneys who reflect your community. Need a Black, Spanish, Christian, or Jewish injury lawyer, or generally someone familiar with cultural nuances? We support you in finding a local vehicle accident attorney to match your needs.
</p>
</div>
<div className="flex justify-start">
<button

              className="bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-semibold px-4 py-2 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 text-base sm:text-lg min-w-[120px] w-fit"
onClick={() => {
              const el = document.getElementById('injury-compensation-form');
              if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }}
              aria-label="Protect your rights today"
>

              Protect Your Rights Today
</button>
</div>
</div>
</section>

      {/* Right Image Section */}
<section className="md:w-2/5 w-full flex justify-center items-center p-0 md:p-0" aria-label="Injury Lawyer Image" style={{height: '100vh'}}>
<img

          src='https://dwy9ix7d387oz.cloudfront.net/attachments/2025/8/77c06dd8-0a35-482b-8c03-99c44abe53b7.png'

          alt="Personal Injury Lawyer helping client"

          className="w-full h-full object-cover rounded-none shadow-none"

          style={{height: '100vh', width: '100%'}}

          loading="lazy"

        />
</section>
</main>

  );

};
 
export default SectionSix;
 